import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Index from './pages/Index';
import Medals from './pages/Medals'; 
import Materials from './pages/Materials';
import Schedule from './pages/Schedule';


const RootRoutes = () => (
    <Switch>
        <Route exact path="/olympic2018" render={() => <Index />} />
        <Route exact path="/olympic2018/medalnyj-zachet-olimpiada-2018" render={() => <Medals />} />
        <Route exact path="/olympic2018/materials" render={() => <Materials />} />
        <Route exact path="/olympic2018/kalendar-olimpiada-2018" render={() => <Schedule />} />
        <Route render={() => <div>404</div>} />
    </Switch>
);

export default RootRoutes;



// WEBPACK FOOTER //
// ./src/routes.jsx